import { Component, Input } from '@angular/core';
declare var bootstrap: any;

@Component({
  selector: 'app-image-service',
  templateUrl: './image-service.component.html',
  styleUrls: ['./image-service.component.css']
})
export class ImageServiceComponent  {
  @Input() data!: any;
  @Input() language!: string;
  selectedImage: string = '';

  openImage(imagePath: string): void {
    this.selectedImage = imagePath;
    const modalElement = document.getElementById('imageModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
}